<template>
    <div class="carousel">
        <img class="carousel-image" :src="current.visual" :alt="current.legend">
        <div class="carousel-legend">{{ current.legend }}</div>
        <div class="carousel-thumbnails">
            <div class="row justify-content-center">
                <div class="col-md-1 pr-0 d-none d-md-block text-center">
                    <button class="carousel-button carousel-button-prev btn" :disabled="!active" @click="prev">
                        <slot name="prev-icon">&lt;</slot>
                    </button>
                </div>
                <div class="col-md-10 px-md-0">
                    <swiper :options="swiperOptions" @slide-change="handleSlideChange" ref="swiper">
                        <slot></slot>
                    </swiper>
                </div>
                <div class="col-md-1 pl-0 d-none d-md-block text-center">
                    <button class="carousel-button carousel-button-next btn" :disabled="active===visuals.length-1" @click="next">
                        <slot name="next-icon">&gt;</slot>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import responsive from '../mixins/responsive';

    export default {
        mixins: [responsive],
        props: {
            visuals: Array,
            medium: Boolean
        },
        data() {
            return {
                currentImage: '',
                active: 0
            }
        },
        computed: {
            swiperOptions() {
                return {
                    spaceBetween: 15,
                    breakpoints: {
                        [this.breakpoints.sm]: { // down sm
                            slidesPerView: 2,
                        },
                        [this.breakpoints.md]: { // down md
                            slidesPerView: 3,
                        },
                        [this.breakpoints.lg]: { // down lg
                            slidesPerView: this.medium ? 3 : 4,
                        }
                    },
                    slidesPerView: this.medium ? 4 : 5,
                    slideToClickedSlide: true,
                    centeredSlides: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    pagination: {
                        el: '.swiper-pagination',
                    },
                }
            },
            current() {
                return this.visuals[this.active];
            }
        },
        methods: {
            handleSlideChange() {
                let { swiper } = this.$refs.swiper;
                this.active = swiper.realIndex;
            },
            prev() {
                this.$refs.swiper.swiper.slidePrev();
            },
            next() {
                this.$refs.swiper.swiper.slideNext();
            }
        },
        mounted() {
        }
    }
</script>